// extracted by mini-css-extract-plugin
module.exports = {"option":"option-1NPvn","small":"small-3h3Yv","header":"header-6flEB","recommended":"recommended-2o-nf"};